<template>
  <v-app style="max-height: 380px" class="rounded">
    <div>
      <div class="">
        <!--begin::Header-->
        <div class="card-header border-0 py-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">
              {{ $t("news.title") }}
            </span>
            <span class="text-muted mt-3 font-weight-bold font-size-sm"></span>
          </h3>
        </div>
        <div class="text-center justify-content-center" v-if="!news.length">
          <i class="fa fa-frown fa-7x" style="color: #7e8299"></i>
          <h2 class="text-dark-50 my-2 text-center">{{ $t("news.noNews") }}</h2>
        </div>

        <v-slide-group
          v-model="model"
          class="px-1 pb-5 mb-5"
          active-class="success"
          hide-arrows
        >
          <v-slide-item v-for="(item, index) in news" :key="index">
            <div
              class="card mx-2 border border-sm-1 border-secondary rounded"
              style="height: 260px; width: 265px"
            >
              <img
                :src="coreLandUrl(item.picture)"
                class="card-img-top rounded"
                width="265"
                height="150"
              />
              <div class="card-body p-0">
                <div class="mt-3 mr-2">
                  <h4>
                    <p class="text-truncate" style="width: 17rem">
                      {{ item.title }}
                    </p>
                  </h4>
                </div>
                <hr />
                <div class="row">
                  <div class="col d-inline mt-2 mr-2">
                    <span class="card-text text-dark-50"
                      ><span class="fa fa-clock fa-1x"></span>
                      {{ item.created_at | timeAgo }}</span
                    >
                  </div>
                  <div class="col d-inline" style="text-align: left">
                    <v-btn
                      plain
                      :to="{ name: 'news.index', params: { id: item.id } }"
                      class="text-dark text-hover-primary font-weight-bold"
                    >
                      <span>{{ $t("news.view") }}</span
                      ><span class="fa fa-angle-left fa-1x"></span>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </v-slide-item>
        </v-slide-group>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "NewsSlider",
  data: () => ({
    model: null,
    news: [],
    loading: false, // اضافه شد چون در getNews استفاده شده
  }),
  methods: {
    getNews() {
      this.loading = true;
      this.requestApiGet(`contentIndex?type=news`)
        .then(({ data }) => {
          this.news = data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    actions(data, type) {
      this[type](data);
    },
  },
  created() {
    this.getNews();
  },
};
</script>

<style scoped></style>
